import { __rest } from 'tslib';
import React from 'react';
import { s as styled } from './styled-112a8bd0.js';

const getBackground = (props) => {
    const { variant, theme } = props;
    return ((variant && (theme.brand[variant] || theme.colors[variant])) ||
        variant ||
        theme.colors.dark);
};
const StyledTag = styled.div((props) => `
  background-color: ${props.outline ? '#fff' : getBackground(props)};
  color: ${props.outline ? getBackground(props) : props.theme.colors.white};
  border: ${props.outline ? `1px solid ${getBackground(props)}` : ''} ;
  display: inline;
  padding: 2px 8px;
  border-radius: 2px;
  font-size: 10px;
  line-height: 12px;
  font-weight: 500;
  align-self: center;
  `);
const Tag = (_a) => {
    var { variant, outline = false, children, className } = _a, props = __rest(_a, ["variant", "outline", "children", "className"]);
    return (React.createElement(StyledTag, Object.assign({ className: className, outline: outline, variant: variant }, props), children));
};

export { Tag as T };
